<template>
    <div class="el-col el-col-11"> 
         <el-select v-model="selMethods" placeholder="全部">
            <el-option v-for="item in methods" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
        </el-select>
    </div>
</template>
<script>
import { Select} from 'element-ui'
import api from '../../../com/ajax'
import config from '../../../com/config'

export default {
  name: 'app',
    components: {
        Select
    },
    data () {
        return {
            // 对象属性
            methods:[{
                'value':'',
                'name':'全部',
            },{
                'value':'1',
                'name':'住院',
            },{
                'value':'2',
                'name':'回家',
            },{
                'value':'3',
                'name':'离园',
            }],
            selMethods:''
        }
    },
    props:{
        selMethods:{
            type:String,
            default:''
        }
    },
    watch:{
        selMethods(val){
                this.$emit('update:value', val)           
        }
    },
    created:function(){
       
    }
}
</script>
<style>
    .el-popper[x-placement^=bottom] .popper__arrow{
        left:50% !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/reports/codeCom/treatmethod.vue?23a76c6d